import type { CategoryBreakdown } from '@apply/lending-limits';
import { BridgeRows } from '../components/lendingLimitAccordionPanel/components/common/constants/tables/rows/BridgeRows';
import { IBridgeTableRow } from '../components/lendingLimitAccordionPanel/components/common/constants/tables/interfaces/IBridgeTableRow';
import { combineRows, detailRow, fromBucket } from './shared';

/**
 * Bridge grid rows.
 *
 * The total row is *not* the sum of the two above it. Sold bridge is reported for
 * context but is no longer exposure, and retained bridge counts only up to the cap —
 * so the Bridge total is the capped retained figure, with the overflow appearing on the
 * Core grid instead.
 *
 * Repayments are not capped: the total row sums both rows' repayments, since a
 * repayment is experience regardless of which side of the cap the loan sat on.
 */
export function toBridgeRows(breakdown: CategoryBreakdown): IBridgeTableRow[] {
    const sold = fromBucket(breakdown.buckets.soldBridge);
    const retained = fromBucket(breakdown.buckets.retainedBridge);

    const total = {
        ...combineRows([sold, retained]),
        outstandingAmount: breakdown.bridge.capped,
        outstandingLoans: retained.outstandingLoans,
    };

    return [
        { summaryItemType: BridgeRows.SoldBridge, ...detailRow(sold) },
        { summaryItemType: BridgeRows.TotalBridgeRet, ...detailRow(retained) },
        { summaryItemType: BridgeRows.BridgeSummary, ...detailRow(total) },
    ];
}
